module.exports = __webpack_public_path__ + "files/e8a3b53d15d6cf71f2b5ca66f7f0b1d2.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/exo2-italic-webfont.svg
 ** module id = 916
 ** module chunks = 0
 **/